import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AdvancedSearchService } from '../advanced-search.service';
import { IAdvancedAddressSearchFormValues } from '../models';

export const advancedAddressSearchFormDataResolver: ResolveFn<
  IAdvancedAddressSearchFormValues | undefined
> = (route) => inject(AdvancedSearchService).getAddressSearchFormValues(route);
